import type { ReactNode } from "react";
import { cn } from "../lib/cn";

export type SkeletonVariant = "rect" | "text" | "circle";

export interface SkeletonProps {
	className?: string;
	variant?: SkeletonVariant;
}

const VARIANT_CLASSES: Record<SkeletonVariant, string> = {
	rect: "rounded-md",
	text: "h-4 rounded",
	circle: "rounded-full",
};

function Skeleton({ className, variant = "rect" }: SkeletonProps): ReactNode {
	return (
		<div
			className={cn(
				"animate-pulse bg-muted",
				VARIANT_CLASSES[variant],
				className,
			)}
			aria-hidden="true"
		/>
	);
}
Skeleton.displayName = "Skeleton";

export default Skeleton;
export { Skeleton };
